module.exports = __webpack_public_path__ + "static/img/step_1.45f3c14a.png";